import React, {useEffect} from 'react'
import Modal from '../../../../../../libs/_fri/components/CustomModal/CustomModal'
import {useFormik} from 'formik'
import {useSelector} from 'react-redux'
import {RootState} from '../../../../../../redux/store'
import {
  useEditUserMutation,
  useGetUserDetailMutation,
} from '../../../../../../redux/api/services/user'
import {IFormEditUser, schemaEditUser} from '../../core/interface'
import {useListView} from '../../core/ListViewProvider'
import {getOppositeStatus} from '../../../../../../helpers/utilities'

export const UserEditModal = () => {
  const infoState = useSelector((state: RootState) => state.info)
  const [editUser, editUserStatus] = useEditUserMutation()
  const [getDetailUser, getDetailUserStatus] = useGetUserDetailMutation()
  const {userIdForUpdate, setUserIdForUpdate} = useListView()

  const initialValues: IFormEditUser = {
    name: getDetailUserStatus.data?.responseContent.name || '',
    email: getDetailUserStatus.data?.responseContent.emailAddress || '',
    phoneNumber: getDetailUserStatus.data?.responseContent.contactPhoneNumber || '',
    status: getDetailUserStatus.data?.responseContent.status || 'active',
  }

  const handleClose = () => {
    setUserIdForUpdate(undefined)
  }

  useEffect(() => {
    if (!userIdForUpdate) return
    getDetailUser({info: infoState, requestContent: {id: userIdForUpdate}})
  }, [userIdForUpdate])

  useEffect(() => {
    if (!editUserStatus.isSuccess) return
    editUserStatus.reset()
    formik.resetForm()
    handleClose()
  }, [editUserStatus.isSuccess])

  const handleSubmit = (values: IFormEditUser) => {
    if (!getDetailUserStatus.data?.responseContent.id) return
    const requestData = {
      info: infoState,
      requestContent: {
        id: getDetailUserStatus.data?.responseContent.id,
        name: values.name,
        email: values.email,
        phoneNumber: values.phoneNumber,
        status: values.status,
      },
    }
    editUser(requestData)
  }

  const formik = useFormik({
    initialValues,
    validationSchema: schemaEditUser,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  })

  return (
    <Modal
      handleClose={handleClose}
      handleConfirm={formik.handleSubmit}
      variant='primary'
      size='lg'
      isLoading={editUserStatus.isLoading}
      disableButtons={getDetailUserStatus.isError}
    >
      <div className='d-flex flex-column px-21'>
        <span className='fs-2x text-primary-dark fw-semibold text-center mb-15'>
          Editar usuario
        </span>

        <div className='row mb-11'>
          <div className='col-md-12'>
            <label className='form-label mb-3 text-gray fs-2'>Nombre</label>
            <input
              name='name'
              type='text'
              placeholder='Nombre completo'
              className='form-control form-control-lg form-control-solid text-primary-dark fs-2'
              value={formik.values.name}
              onChange={formik.handleChange}
            />
            <div className='text-danger mt-2'>{formik.touched.name && formik.errors.name}</div>
          </div>
        </div>

        <div className='row mb-11'>
          <div className='col-md-12'>
            <label className='form-label mb-3 text-gray fs-2'>Correo electrónico</label>
            <input
              name='email'
              type='email'
              placeholder='correo@ejemplo.com'
              className='form-control form-control-lg form-control-solid text-gray-dark fs-2'
              value={formik.values.email}
              onChange={formik.handleChange}
              disabled
            />
            <div className='text-danger mt-2'>{formik.touched.email && formik.errors.email}</div>
          </div>
        </div>

        <div className='row mb-11'>
          <div className='col-md-12'>
            <label className='form-label mb-3 text-gray fs-2'>Teléfono</label>
            <input
              name='phoneNumber'
              type='text'
              placeholder='Número de teléfono'
              className='form-control form-control-lg form-control-solid text-primary-dark fs-2'
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
            />
            <div className='text-danger mt-2'>
              {formik.touched.phoneNumber && formik.errors.phoneNumber}
            </div>
          </div>
        </div>

        <div className='row mb-11'>
          <div className='col-md-12'>
            <label className='form-label mb-3 text-gray fs-2'>Estado</label>
            <div className={'pt-1'}>
              <div className='form-check form-switch'>
                <input
                  type='checkbox'
                  className='form-check-input'
                  name='status'
                  checked={formik.values.status === 'active'}
                  onChange={() => {
                    if (formik.values.status === 'deleted') return

                    formik.setFieldValue('status', getOppositeStatus(formik.values.status))
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}
